var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3503_12752)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8425 5.516H1.34207C0.917633 5.516 0.575012 5.19526 0.575012 4.79792C0.575012 4.40058 0.917633 4.07983 1.34207 4.07983H23.8425C24.267 4.07983 24.6096 4.40058 24.6096 4.79792C24.6096 5.19526 24.267 5.516 23.8425 5.516Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4276 5.51596H8.75699C8.33255 5.51596 7.98993 5.19521 7.98993 4.79787V2.40426C7.98993 1.21702 9.0229 0.25 10.2911 0.25H14.8935C16.1617 0.25 17.1947 1.21702 17.1947 2.40426V4.79787C17.1947 5.19521 16.852 5.51596 16.4276 5.51596ZM9.52405 4.07979H15.6605V2.40426C15.6605 2.00691 15.3179 1.68617 14.8935 1.68617H10.2911C9.86667 1.68617 9.52405 2.00691 9.52405 2.40426V4.07979Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2912 17.7233C9.86673 17.7233 9.52411 17.4026 9.52411 17.0053V9.82441C9.52411 9.42707 9.86673 9.10632 10.2912 9.10632C10.7156 9.10632 11.0582 9.42707 11.0582 9.82441V17.0053C11.0582 17.4026 10.7156 17.7233 10.2912 17.7233Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8935 17.7233C14.469 17.7233 14.1264 17.4026 14.1264 17.0053V9.82441C14.1264 9.42707 14.469 9.10632 14.8935 9.10632C15.3179 9.10632 15.6605 9.42707 15.6605 9.82441V17.0053C15.6605 17.4026 15.3179 17.7233 14.8935 17.7233Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.09508 22.75C5.90358 22.75 4.90128 21.8788 4.81435 20.7633L3.39273 4.85537C3.37228 4.6543 3.44898 4.45803 3.59217 4.30962C3.73535 4.16122 3.9399 4.07983 4.15468 4.07983H21.03C21.2448 4.07983 21.4493 4.166 21.5925 4.30962C21.7357 4.45803 21.8124 4.6543 21.792 4.85537L20.3703 20.7633C20.2783 21.874 19.276 22.7453 18.0845 22.7453H7.09508V22.75ZM7.09508 21.3139H18.0845C18.4783 21.3139 18.8107 21.0266 18.8413 20.658C18.8413 20.658 18.8413 20.658 18.8413 20.6532L20.1914 5.516H4.98822L6.33824 20.6532C6.36893 21.0266 6.70132 21.3139 7.09508 21.3139Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3503_12752"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.0346,
    height: 22.5,
    fill: "white",
    transform: "translate(0.575012 0.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.5315ca95ed24906b3003de2782dae63a.svg";
export { ForwardRef as ReactComponent };